export class CourseActivationResponse {

	user: number;
	lastLessonBlock: number;

}
